/**
 * Country enum with ISO 3166-1 alpha-3 codes
 * Includes all 252 countries and territories with bilingual labels (English/French)
 */

export enum Country {
  // Priority countries
  CAN = "CAN",
  USA = "USA",

  // All countries alphabetically by ISO code
  AFG = "AFG",
  ALA = "ALA",
  ALB = "ALB",
  DZA = "DZA",
  ASM = "ASM",
  AND = "AND",
  AGO = "AGO",
  AIA = "AIA",
  ATA = "ATA",
  ATG = "ATG",
  ARG = "ARG",
  ARM = "ARM",
  ABW = "ABW",
  AUS = "AUS",
  AUT = "AUT",
  AZE = "AZE",
  BHS = "BHS",
  BHR = "BHR",
  BGD = "BGD",
  BRB = "BRB",
  BLR = "BLR",
  BEL = "BEL",
  BLZ = "BLZ",
  BEN = "BEN",
  BMU = "BMU",
  BTN = "BTN",
  BOL = "BOL",
  BES = "BES",
  BIH = "BIH",
  BWA = "BWA",
  BVT = "BVT",
  BRA = "BRA",
  IOT = "IOT",
  BRN = "BRN",
  BGR = "BGR",
  BFA = "BFA",
  BDI = "BDI",
  CPV = "CPV",
  KHM = "KHM",
  CMR = "CMR",
  CYM = "CYM",
  CAF = "CAF",
  TCD = "TCD",
  CHL = "CHL",
  CHN = "CHN",
  CXR = "CXR",
  CCK = "CCK",
  COL = "COL",
  COM = "COM",
  COG = "COG",
  COD = "COD",
  COK = "COK",
  CRI = "CRI",
  CIV = "CIV",
  HRV = "HRV",
  CUB = "CUB",
  CUW = "CUW",
  CYP = "CYP",
  CZE = "CZE",
  DNK = "DNK",
  DJI = "DJI",
  DMA = "DMA",
  DOM = "DOM",
  ECU = "ECU",
  EGY = "EGY",
  SLV = "SLV",
  GNQ = "GNQ",
  ERI = "ERI",
  EST = "EST",
  SWZ = "SWZ",
  ETH = "ETH",
  FLK = "FLK",
  FRO = "FRO",
  FJI = "FJI",
  FIN = "FIN",
  FRA = "FRA",
  GUF = "GUF",
  PYF = "PYF",
  ATF = "ATF",
  GAB = "GAB",
  GMB = "GMB",
  GEO = "GEO",
  DEU = "DEU",
  GHA = "GHA",
  GIB = "GIB",
  GRC = "GRC",
  GRL = "GRL",
  GRD = "GRD",
  GLP = "GLP",
  GUM = "GUM",
  GTM = "GTM",
  GGY = "GGY",
  GIN = "GIN",
  GNB = "GNB",
  GUY = "GUY",
  HTI = "HTI",
  HMD = "HMD",
  VAT = "VAT",
  HND = "HND",
  HKG = "HKG",
  HUN = "HUN",
  ISL = "ISL",
  IND = "IND",
  IDN = "IDN",
  IRN = "IRN",
  IRQ = "IRQ",
  IRL = "IRL",
  IMN = "IMN",
  ISR = "ISR",
  ITA = "ITA",
  JAM = "JAM",
  JPN = "JPN",
  JEY = "JEY",
  JOR = "JOR",
  KAZ = "KAZ",
  KEN = "KEN",
  KIR = "KIR",
  PRK = "PRK",
  KOR = "KOR",
  KWT = "KWT",
  KGZ = "KGZ",
  LAO = "LAO",
  LVA = "LVA",
  LBN = "LBN",
  LSO = "LSO",
  LBR = "LBR",
  LBY = "LBY",
  LIE = "LIE",
  LTU = "LTU",
  LUX = "LUX",
  MAC = "MAC",
  MDG = "MDG",
  MWI = "MWI",
  MYS = "MYS",
  MDV = "MDV",
  MLI = "MLI",
  MLT = "MLT",
  MHL = "MHL",
  MTQ = "MTQ",
  MRT = "MRT",
  MUS = "MUS",
  MYT = "MYT",
  MEX = "MEX",
  FSM = "FSM",
  MDA = "MDA",
  MCO = "MCO",
  MNG = "MNG",
  MNE = "MNE",
  MSR = "MSR",
  MAR = "MAR",
  MOZ = "MOZ",
  MMR = "MMR",
  NAM = "NAM",
  NRU = "NRU",
  NPL = "NPL",
  NLD = "NLD",
  NCL = "NCL",
  NZL = "NZL",
  NIC = "NIC",
  NER = "NER",
  NGA = "NGA",
  NIU = "NIU",
  NFK = "NFK",
  MKD = "MKD",
  MNP = "MNP",
  NOR = "NOR",
  OMN = "OMN",
  PAK = "PAK",
  PLW = "PLW",
  PSE = "PSE",
  PAN = "PAN",
  PNG = "PNG",
  PRY = "PRY",
  PER = "PER",
  PHL = "PHL",
  PCN = "PCN",
  POL = "POL",
  PRT = "PRT",
  PRI = "PRI",
  QAT = "QAT",
  REU = "REU",
  ROU = "ROU",
  RUS = "RUS",
  RWA = "RWA",
  BLM = "BLM",
  SHN = "SHN",
  KNA = "KNA",
  LCA = "LCA",
  MAF = "MAF",
  SPM = "SPM",
  VCT = "VCT",
  WSM = "WSM",
  SMR = "SMR",
  STP = "STP",
  SAU = "SAU",
  SEN = "SEN",
  SRB = "SRB",
  SYC = "SYC",
  SLE = "SLE",
  SGP = "SGP",
  SXM = "SXM",
  SVK = "SVK",
  SVN = "SVN",
  SLB = "SLB",
  SOM = "SOM",
  ZAF = "ZAF",
  SGS = "SGS",
  SSD = "SSD",
  ESP = "ESP",
  LKA = "LKA",
  SDN = "SDN",
  SUR = "SUR",
  SJM = "SJM",
  SWE = "SWE",
  CHE = "CHE",
  SYR = "SYR",
  TWN = "TWN",
  TJK = "TJK",
  TZA = "TZA",
  THA = "THA",
  TLS = "TLS",
  TGO = "TGO",
  TKL = "TKL",
  TON = "TON",
  TTO = "TTO",
  TUN = "TUN",
  TUR = "TUR",
  TKM = "TKM",
  TCA = "TCA",
  TUV = "TUV",
  UGA = "UGA",
  UKR = "UKR",
  ARE = "ARE",
  GBR = "GBR",
  UMI = "UMI",
  URY = "URY",
  UZB = "UZB",
  VUT = "VUT",
  VEN = "VEN",
  VNM = "VNM",
  VGB = "VGB",
  VIR = "VIR",
  WLF = "WLF",
  ESH = "ESH",
  YEM = "YEM",
  ZMB = "ZMB",
  ZWE = "ZWE",

  // Special entry for Cruise
  X_CRU = "X_CRU",
}

/**
 * Bilingual labels for all countries
 */
export const COUNTRY_LABELS: Record<Country, { en: string; fr: string }> = {
  [Country.CAN]: { en: "Canada", fr: "Canada" },
  [Country.USA]: { en: "United States", fr: "États-Unis" },
  [Country.AFG]: { en: "Afghanistan", fr: "Afghanistan" },
  [Country.ALA]: { en: "Åland Islands", fr: "Îles Åland" },
  [Country.ALB]: { en: "Albania", fr: "Albanie" },
  [Country.DZA]: { en: "Algeria", fr: "Algérie" },
  [Country.ASM]: { en: "American Samoa", fr: "Samoa américaines" },
  [Country.AND]: { en: "Andorra", fr: "Andorre" },
  [Country.AGO]: { en: "Angola", fr: "Angola" },
  [Country.AIA]: { en: "Anguilla", fr: "Anguilla" },
  [Country.ATA]: { en: "Antarctica", fr: "Antarctique" },
  [Country.ATG]: { en: "Antigua and Barbuda", fr: "Antigua-et-Barbuda" },
  [Country.ARG]: { en: "Argentina", fr: "Argentine" },
  [Country.ARM]: { en: "Armenia", fr: "Arménie" },
  [Country.ABW]: { en: "Aruba", fr: "Aruba" },
  [Country.AUS]: { en: "Australia", fr: "Australie" },
  [Country.AUT]: { en: "Austria", fr: "Autriche" },
  [Country.AZE]: { en: "Azerbaijan", fr: "Azerbaïdjan" },
  [Country.BHS]: { en: "Bahamas", fr: "Bahamas" },
  [Country.BHR]: { en: "Bahrain", fr: "Bahreïn" },
  [Country.BGD]: { en: "Bangladesh", fr: "Bangladesh" },
  [Country.BRB]: { en: "Barbados", fr: "Barbade" },
  [Country.BLR]: { en: "Belarus", fr: "Biélorussie" },
  [Country.BEL]: { en: "Belgium", fr: "Belgique" },
  [Country.BLZ]: { en: "Belize", fr: "Belize" },
  [Country.BEN]: { en: "Benin", fr: "Bénin" },
  [Country.BMU]: { en: "Bermuda", fr: "Bermudes" },
  [Country.BTN]: { en: "Bhutan", fr: "Bhoutan" },
  [Country.BOL]: { en: "Bolivia", fr: "Bolivie" },
  [Country.BES]: { en: "Bonaire, Sint Eustatius and Saba", fr: "Bonaire, Saint-Eustache et Saba" },
  [Country.BIH]: { en: "Bosnia and Herzegovina", fr: "Bosnie-Herzégovine" },
  [Country.BWA]: { en: "Botswana", fr: "Botswana" },
  [Country.BVT]: { en: "Bouvet Island", fr: "Île Bouvet" },
  [Country.BRA]: { en: "Brazil", fr: "Brésil" },
  [Country.IOT]: { en: "British Indian Ocean Territory", fr: "Territoire britannique de l'océan Indien" },
  [Country.BRN]: { en: "Brunei Darussalam", fr: "Brunei" },
  [Country.BGR]: { en: "Bulgaria", fr: "Bulgarie" },
  [Country.BFA]: { en: "Burkina Faso", fr: "Burkina Faso" },
  [Country.BDI]: { en: "Burundi", fr: "Burundi" },
  [Country.CPV]: { en: "Cabo Verde", fr: "Cap-Vert" },
  [Country.KHM]: { en: "Cambodia", fr: "Cambodge" },
  [Country.CMR]: { en: "Cameroon", fr: "Cameroun" },
  [Country.CYM]: { en: "Cayman Islands", fr: "Îles Caïmans" },
  [Country.CAF]: { en: "Central African Republic", fr: "République centrafricaine" },
  [Country.TCD]: { en: "Chad", fr: "Tchad" },
  [Country.CHL]: { en: "Chile", fr: "Chili" },
  [Country.CHN]: { en: "China", fr: "Chine" },
  [Country.CXR]: { en: "Christmas Island", fr: "Île Christmas" },
  [Country.CCK]: { en: "Cocos (Keeling) Islands", fr: "Îles Cocos" },
  [Country.COL]: { en: "Colombia", fr: "Colombie" },
  [Country.COM]: { en: "Comoros", fr: "Comores" },
  [Country.COG]: { en: "Congo", fr: "Congo" },
  [Country.COD]: { en: "Congo, Democratic Republic of the", fr: "Congo, République démocratique du" },
  [Country.COK]: { en: "Cook Islands", fr: "Îles Cook" },
  [Country.CRI]: { en: "Costa Rica", fr: "Costa Rica" },
  [Country.CIV]: { en: "Côte d'Ivoire", fr: "Côte d'Ivoire" },
  [Country.HRV]: { en: "Croatia", fr: "Croatie" },
  [Country.CUB]: { en: "Cuba", fr: "Cuba" },
  [Country.CUW]: { en: "Curaçao", fr: "Curaçao" },
  [Country.CYP]: { en: "Cyprus", fr: "Chypre" },
  [Country.CZE]: { en: "Czechia", fr: "Tchéquie" },
  [Country.DNK]: { en: "Denmark", fr: "Danemark" },
  [Country.DJI]: { en: "Djibouti", fr: "Djibouti" },
  [Country.DMA]: { en: "Dominica", fr: "Dominique" },
  [Country.DOM]: { en: "Dominican Republic", fr: "République dominicaine" },
  [Country.ECU]: { en: "Ecuador", fr: "Équateur" },
  [Country.EGY]: { en: "Egypt", fr: "Égypte" },
  [Country.SLV]: { en: "El Salvador", fr: "Salvador" },
  [Country.GNQ]: { en: "Equatorial Guinea", fr: "Guinée équatoriale" },
  [Country.ERI]: { en: "Eritrea", fr: "Érythrée" },
  [Country.EST]: { en: "Estonia", fr: "Estonie" },
  [Country.SWZ]: { en: "Eswatini", fr: "Eswatini" },
  [Country.ETH]: { en: "Ethiopia", fr: "Éthiopie" },
  [Country.FLK]: { en: "Falkland Islands (Malvinas)", fr: "Îles Malouines" },
  [Country.FRO]: { en: "Faroe Islands", fr: "Îles Féroé" },
  [Country.FJI]: { en: "Fiji", fr: "Fidji" },
  [Country.FIN]: { en: "Finland", fr: "Finlande" },
  [Country.FRA]: { en: "France", fr: "France" },
  [Country.GUF]: { en: "French Guiana", fr: "Guyane française" },
  [Country.PYF]: { en: "French Polynesia", fr: "Polynésie française" },
  [Country.ATF]: { en: "French Southern Territories", fr: "Terres australes françaises" },
  [Country.GAB]: { en: "Gabon", fr: "Gabon" },
  [Country.GMB]: { en: "Gambia", fr: "Gambie" },
  [Country.GEO]: { en: "Georgia", fr: "Géorgie" },
  [Country.DEU]: { en: "Germany", fr: "Allemagne" },
  [Country.GHA]: { en: "Ghana", fr: "Ghana" },
  [Country.GIB]: { en: "Gibraltar", fr: "Gibraltar" },
  [Country.GRC]: { en: "Greece", fr: "Grèce" },
  [Country.GRL]: { en: "Greenland", fr: "Groenland" },
  [Country.GRD]: { en: "Grenada", fr: "Grenade" },
  [Country.GLP]: { en: "Guadeloupe", fr: "Guadeloupe" },
  [Country.GUM]: { en: "Guam", fr: "Guam" },
  [Country.GTM]: { en: "Guatemala", fr: "Guatemala" },
  [Country.GGY]: { en: "Guernsey", fr: "Guernesey" },
  [Country.GIN]: { en: "Guinea", fr: "Guinée" },
  [Country.GNB]: { en: "Guinea-Bissau", fr: "Guinée-Bissau" },
  [Country.GUY]: { en: "Guyana", fr: "Guyana" },
  [Country.HTI]: { en: "Haiti", fr: "Haïti" },
  [Country.HMD]: { en: "Heard Island and McDonald Islands", fr: "Îles Heard-et-MacDonald" },
  [Country.VAT]: { en: "Holy See", fr: "Saint-Siège" },
  [Country.HND]: { en: "Honduras", fr: "Honduras" },
  [Country.HKG]: { en: "Hong Kong", fr: "Hong Kong" },
  [Country.HUN]: { en: "Hungary", fr: "Hongrie" },
  [Country.ISL]: { en: "Iceland", fr: "Islande" },
  [Country.IND]: { en: "India", fr: "Inde" },
  [Country.IDN]: { en: "Indonesia", fr: "Indonésie" },
  [Country.IRN]: { en: "Iran", fr: "Iran" },
  [Country.IRQ]: { en: "Iraq", fr: "Irak" },
  [Country.IRL]: { en: "Ireland", fr: "Irlande" },
  [Country.IMN]: { en: "Isle of Man", fr: "Île de Man" },
  [Country.ISR]: { en: "Israel", fr: "Israël" },
  [Country.ITA]: { en: "Italy", fr: "Italie" },
  [Country.JAM]: { en: "Jamaica", fr: "Jamaïque" },
  [Country.JPN]: { en: "Japan", fr: "Japon" },
  [Country.JEY]: { en: "Jersey", fr: "Jersey" },
  [Country.JOR]: { en: "Jordan", fr: "Jordanie" },
  [Country.KAZ]: { en: "Kazakhstan", fr: "Kazakhstan" },
  [Country.KEN]: { en: "Kenya", fr: "Kenya" },
  [Country.KIR]: { en: "Kiribati", fr: "Kiribati" },
  [Country.PRK]: { en: "Korea, Democratic People's Republic of", fr: "Corée du Nord" },
  [Country.KOR]: { en: "Korea, Republic of", fr: "Corée du Sud" },
  [Country.KWT]: { en: "Kuwait", fr: "Koweït" },
  [Country.KGZ]: { en: "Kyrgyzstan", fr: "Kirghizistan" },
  [Country.LAO]: { en: "Lao People's Democratic Republic", fr: "Laos" },
  [Country.LVA]: { en: "Latvia", fr: "Lettonie" },
  [Country.LBN]: { en: "Lebanon", fr: "Liban" },
  [Country.LSO]: { en: "Lesotho", fr: "Lesotho" },
  [Country.LBR]: { en: "Liberia", fr: "Libéria" },
  [Country.LBY]: { en: "Libya", fr: "Libye" },
  [Country.LIE]: { en: "Liechtenstein", fr: "Liechtenstein" },
  [Country.LTU]: { en: "Lithuania", fr: "Lituanie" },
  [Country.LUX]: { en: "Luxembourg", fr: "Luxembourg" },
  [Country.MAC]: { en: "Macao", fr: "Macao" },
  [Country.MDG]: { en: "Madagascar", fr: "Madagascar" },
  [Country.MWI]: { en: "Malawi", fr: "Malawi" },
  [Country.MYS]: { en: "Malaysia", fr: "Malaisie" },
  [Country.MDV]: { en: "Maldives", fr: "Maldives" },
  [Country.MLI]: { en: "Mali", fr: "Mali" },
  [Country.MLT]: { en: "Malta", fr: "Malte" },
  [Country.MHL]: { en: "Marshall Islands", fr: "Îles Marshall" },
  [Country.MTQ]: { en: "Martinique", fr: "Martinique" },
  [Country.MRT]: { en: "Mauritania", fr: "Mauritanie" },
  [Country.MUS]: { en: "Mauritius", fr: "Maurice" },
  [Country.MYT]: { en: "Mayotte", fr: "Mayotte" },
  [Country.MEX]: { en: "Mexico", fr: "Mexique" },
  [Country.FSM]: { en: "Micronesia, Federated States of", fr: "Micronésie" },
  [Country.MDA]: { en: "Moldova", fr: "Moldavie" },
  [Country.MCO]: { en: "Monaco", fr: "Monaco" },
  [Country.MNG]: { en: "Mongolia", fr: "Mongolie" },
  [Country.MNE]: { en: "Montenegro", fr: "Monténégro" },
  [Country.MSR]: { en: "Montserrat", fr: "Montserrat" },
  [Country.MAR]: { en: "Morocco", fr: "Maroc" },
  [Country.MOZ]: { en: "Mozambique", fr: "Mozambique" },
  [Country.MMR]: { en: "Myanmar", fr: "Myanmar" },
  [Country.NAM]: { en: "Namibia", fr: "Namibie" },
  [Country.NRU]: { en: "Nauru", fr: "Nauru" },
  [Country.NPL]: { en: "Nepal", fr: "Népal" },
  [Country.NLD]: { en: "Netherlands", fr: "Pays-Bas" },
  [Country.NCL]: { en: "New Caledonia", fr: "Nouvelle-Calédonie" },
  [Country.NZL]: { en: "New Zealand", fr: "Nouvelle-Zélande" },
  [Country.NIC]: { en: "Nicaragua", fr: "Nicaragua" },
  [Country.NER]: { en: "Niger", fr: "Niger" },
  [Country.NGA]: { en: "Nigeria", fr: "Nigéria" },
  [Country.NIU]: { en: "Niue", fr: "Niué" },
  [Country.NFK]: { en: "Norfolk Island", fr: "Île Norfolk" },
  [Country.MKD]: { en: "North Macedonia", fr: "Macédoine du Nord" },
  [Country.MNP]: { en: "Northern Mariana Islands", fr: "Îles Mariannes du Nord" },
  [Country.NOR]: { en: "Norway", fr: "Norvège" },
  [Country.OMN]: { en: "Oman", fr: "Oman" },
  [Country.PAK]: { en: "Pakistan", fr: "Pakistan" },
  [Country.PLW]: { en: "Palau", fr: "Palaos" },
  [Country.PSE]: { en: "Palestine, State of", fr: "Palestine" },
  [Country.PAN]: { en: "Panama", fr: "Panama" },
  [Country.PNG]: { en: "Papua New Guinea", fr: "Papouasie-Nouvelle-Guinée" },
  [Country.PRY]: { en: "Paraguay", fr: "Paraguay" },
  [Country.PER]: { en: "Peru", fr: "Pérou" },
  [Country.PHL]: { en: "Philippines", fr: "Philippines" },
  [Country.PCN]: { en: "Pitcairn", fr: "Pitcairn" },
  [Country.POL]: { en: "Poland", fr: "Pologne" },
  [Country.PRT]: { en: "Portugal", fr: "Portugal" },
  [Country.PRI]: { en: "Puerto Rico", fr: "Porto Rico" },
  [Country.QAT]: { en: "Qatar", fr: "Qatar" },
  [Country.REU]: { en: "Réunion", fr: "La Réunion" },
  [Country.ROU]: { en: "Romania", fr: "Roumanie" },
  [Country.RUS]: { en: "Russian Federation", fr: "Russie" },
  [Country.RWA]: { en: "Rwanda", fr: "Rwanda" },
  [Country.BLM]: { en: "Saint Barthélemy", fr: "Saint-Barthélemy" },
  [Country.SHN]: { en: "Saint Helena, Ascension and Tristan da Cunha", fr: "Sainte-Hélène, Ascension et Tristan da Cunha" },
  [Country.KNA]: { en: "Saint Kitts and Nevis", fr: "Saint-Kitts-et-Nevis" },
  [Country.LCA]: { en: "Saint Lucia", fr: "Sainte-Lucie" },
  [Country.MAF]: { en: "Saint Martin (French part)", fr: "Saint-Martin (partie française)" },
  [Country.SPM]: { en: "Saint Pierre and Miquelon", fr: "Saint-Pierre-et-Miquelon" },
  [Country.VCT]: { en: "Saint Vincent and the Grenadines", fr: "Saint-Vincent-et-les-Grenadines" },
  [Country.WSM]: { en: "Samoa", fr: "Samoa" },
  [Country.SMR]: { en: "San Marino", fr: "Saint-Marin" },
  [Country.STP]: { en: "Sao Tome and Principe", fr: "Sao Tomé-et-Principe" },
  [Country.SAU]: { en: "Saudi Arabia", fr: "Arabie saoudite" },
  [Country.SEN]: { en: "Senegal", fr: "Sénégal" },
  [Country.SRB]: { en: "Serbia", fr: "Serbie" },
  [Country.SYC]: { en: "Seychelles", fr: "Seychelles" },
  [Country.SLE]: { en: "Sierra Leone", fr: "Sierra Leone" },
  [Country.SGP]: { en: "Singapore", fr: "Singapour" },
  [Country.SXM]: { en: "Sint Maarten (Dutch part)", fr: "Saint-Martin (partie néerlandaise)" },
  [Country.SVK]: { en: "Slovakia", fr: "Slovaquie" },
  [Country.SVN]: { en: "Slovenia", fr: "Slovénie" },
  [Country.SLB]: { en: "Solomon Islands", fr: "Îles Salomon" },
  [Country.SOM]: { en: "Somalia", fr: "Somalie" },
  [Country.ZAF]: { en: "South Africa", fr: "Afrique du Sud" },
  [Country.SGS]: { en: "South Georgia and the South Sandwich Islands", fr: "Géorgie du Sud-et-les Îles Sandwich du Sud" },
  [Country.SSD]: { en: "South Sudan", fr: "Soudan du Sud" },
  [Country.ESP]: { en: "Spain", fr: "Espagne" },
  [Country.LKA]: { en: "Sri Lanka", fr: "Sri Lanka" },
  [Country.SDN]: { en: "Sudan", fr: "Soudan" },
  [Country.SUR]: { en: "Suriname", fr: "Suriname" },
  [Country.SJM]: { en: "Svalbard and Jan Mayen", fr: "Svalbard et Jan Mayen" },
  [Country.SWE]: { en: "Sweden", fr: "Suède" },
  [Country.CHE]: { en: "Switzerland", fr: "Suisse" },
  [Country.SYR]: { en: "Syrian Arab Republic", fr: "Syrie" },
  [Country.TWN]: { en: "Taiwan", fr: "Taïwan" },
  [Country.TJK]: { en: "Tajikistan", fr: "Tadjikistan" },
  [Country.TZA]: { en: "Tanzania", fr: "Tanzanie" },
  [Country.THA]: { en: "Thailand", fr: "Thaïlande" },
  [Country.TLS]: { en: "Timor-Leste", fr: "Timor-Leste" },
  [Country.TGO]: { en: "Togo", fr: "Togo" },
  [Country.TKL]: { en: "Tokelau", fr: "Tokelau" },
  [Country.TON]: { en: "Tonga", fr: "Tonga" },
  [Country.TTO]: { en: "Trinidad and Tobago", fr: "Trinité-et-Tobago" },
  [Country.TUN]: { en: "Tunisia", fr: "Tunisie" },
  [Country.TUR]: { en: "Turkey", fr: "Turquie" },
  [Country.TKM]: { en: "Turkmenistan", fr: "Turkménistan" },
  [Country.TCA]: { en: "Turks and Caicos Islands", fr: "Îles Turques-et-Caïques" },
  [Country.TUV]: { en: "Tuvalu", fr: "Tuvalu" },
  [Country.UGA]: { en: "Uganda", fr: "Ouganda" },
  [Country.UKR]: { en: "Ukraine", fr: "Ukraine" },
  [Country.ARE]: { en: "United Arab Emirates", fr: "Émirats arabes unis" },
  [Country.GBR]: { en: "United Kingdom", fr: "Royaume-Uni" },
  [Country.UMI]: { en: "United States Minor Outlying Islands", fr: "Îles mineures éloignées des États-Unis" },
  [Country.URY]: { en: "Uruguay", fr: "Uruguay" },
  [Country.UZB]: { en: "Uzbekistan", fr: "Ouzbékistan" },
  [Country.VUT]: { en: "Vanuatu", fr: "Vanuatu" },
  [Country.VEN]: { en: "Venezuela", fr: "Venezuela" },
  [Country.VNM]: { en: "Viet Nam", fr: "Viêt Nam" },
  [Country.VGB]: { en: "Virgin Islands, British", fr: "Îles Vierges britanniques" },
  [Country.VIR]: { en: "Virgin Islands, U.S.", fr: "Îles Vierges des États-Unis" },
  [Country.WLF]: { en: "Wallis and Futuna", fr: "Wallis-et-Futuna" },
  [Country.ESH]: { en: "Western Sahara", fr: "Sahara occidental" },
  [Country.YEM]: { en: "Yemen", fr: "Yémen" },
  [Country.ZMB]: { en: "Zambia", fr: "Zambie" },
  [Country.ZWE]: { en: "Zimbabwe", fr: "Zimbabwe" },
  [Country.X_CRU]: { en: "Cruise", fr: "Croisière" },
};

/**
 * Get dropdown options for country selection
 * @param language - Language code ('en' or 'fr')
 * @returns Array of {value, label} objects sorted alphabetically by label
 */
export function getCountryOptions(language: 'en' | 'fr'): Array<{ value: string; label: string }> {
  // Map and filter out any undefined labels
  const options = Object.entries(COUNTRY_LABELS)
    .map(([code, labels]) => ({
      value: code,
      label: labels?.[language] || labels?.en || code,
    }))
    .filter(option => option.label !== undefined)
    .sort((a, b) => {
      // Prioritize CAN and USA at the top
      if (a.value === Country.CAN) return -1;
      if (b.value === Country.CAN) return 1;
      if (a.value === Country.USA) return -1;
      if (b.value === Country.USA) return 1;
      // Then alphabetically
      return a.label.localeCompare(b.label, language);
    });

  return options;
}

/**
 * Get the label for a specific country code
 * @param code - Country enum value
 * @param language - Language code ('en' or 'fr')
 * @returns Country label in the specified language
 */
export function getCountryLabel(code: Country, language: 'en' | 'fr'): string {
  const entry = COUNTRY_LABELS[code];
  if (!entry) {
    console.warn(`[Country] Unknown country code: "${code}" — falling back to raw value`);
    return String(code);
  }
  return entry[language];
}
